import React, { useState, useEffect } from 'react';
import api from '../../api';
import './QuestionPapersPage.css';
import BlogsSection from '../PublicHome/sections/BlogsSection';
export default function QuestionPapersPage({ onNavigate }) {
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const res = await api.get('/question_papers.php');
        const data = Array.isArray(res.data) ? res.data : [];
        // Sort newest uploaded first
        data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setPapers(data);
      } catch (err) {
        console.error("Failed to load question papers:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPapers();
  }, []);

  const getFullUrl = (url) => {
    if (!url) return '';
    return url.startsWith('http') || url.startsWith('/') 
      ? url 
      : `${api.defaults.baseURL}/${url}`;
  };

  return (
    <>
    <div className="qp-page">
      {/* ── Page Header & Breadcrumb ── */}
      <header className="qp-page__header">
        <div className="qp-page__header-overlay" />
        <div className="qp-page__header-content">
          <nav className="qp-page__breadcrumb" aria-label="Breadcrumb">
            <span className="qp-page__breadcrumb-item" onClick={() => onNavigate?.('home')}>
              Home
            </span>
            <span className="qp-page__breadcrumb-separator">/</span>
            <span className="qp-page__breadcrumb-item qp-page__breadcrumb-item--active">
              Question Papers
            </span>
          </nav>
          <h1 className="qp-page__title">Question Papers Archive</h1>
          <p className="qp-page__subtitle">
            Browse and download previous year university examination question papers.
          </p>
        </div>
      </header>

      {/* ── Main Grid Content ── */}
      <main className="qp-page__main">
        {loading ? (
          <div className="qp-page__loading">
            <i className="fa-solid fa-spinner fa-spin qp-page__spinner"></i>
            <p>Loading question papers...</p>
          </div>
        ) : papers.length === 0 ? (
          <div className="qp-page__empty">
            <i className="fa-regular fa-folder-open qp-page__empty-icon"></i>
            <h3>No Question Papers Found</h3>
            <p>The library has not uploaded any question papers yet. Check back soon!</p>
            <button className="qp-page__back-btn" onClick={() => onNavigate?.('home')}>
              Back to Home
            </button>
          </div>
        ) : (
          <div className="qp-page__grid">
            {papers.map((paper, idx) => {
              const fileUrl = getFullUrl(paper.image_url);
              return (
                <article key={paper.id || idx} className="qp-card">
                  {/* Card Image Wrapper */}
                  <div className="qp-card__media">
                    {paper.image_url ? (
                      <img src={fileUrl} alt={paper.title} className="qp-card__img" />
                    ) : (
                      <div className="qp-card__media-fallback">
                        <i className="fa-solid fa-file-pdf"></i>
                      </div>
                    )}
                    <div className="qp-card__overlay">
                      {fileUrl && (
                        <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="qp-card__overlay-btn">
                          <i className="fa-solid fa-eye"></i> Quick View
                        </a>
                      )}
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="qp-card__content">
                    <h3 className="qp-card__title" title={paper.title}>
                      {paper.title}
                    </h3>
                    <div className="qp-card__meta">
                      <span className="qp-card__date">
                        <i className="fa-regular fa-calendar-days"></i>
                        Uploaded: {new Date(paper.created_at).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  {/* Card Footer CTA */}
                  <div className="qp-card__footer">
                    {fileUrl ? (
                      <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="qp-card__download-btn">
                        <i className="fa-solid fa-cloud-arrow-down"></i>
                        <span>Download Paper</span>
                      </a>
                    ) : (
                      <span className="qp-card__no-file">No document attached</span>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </main>
    </div>
<BlogsSection/>

    </>
  );
}
